import { PersonAdd, DeleteOutline, Check, Close } from '@mui/icons-material';
import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { useApi } from '../../Api/useApi';
import { AddRemoveProjectToUserRequest, ProjectsRycApiClient, UserDto, UserForProjectDto, UsersRycApiClient } from '../../Api/ApiServer';
import { useParams } from 'react-router';
import { useProject } from '../../Contexts/Hooks/useProject';
import { RycIsProjectModule } from '../../Enums/RycIsProjectModule';
import UsersSelect from '../../Shared/UsersSelect';
import DeleteDialog from '../../Shared/DeleteDialog';

export interface IProjectUsersProps {
    projectId?: number;
}

export default function ProjectUsers(props: IProjectUsersProps) {
    const params = useParams();
    const { setCurrentModule, setMenuButtons } = useProject();
    const projectId = React.useMemo(() => {
        if (props.projectId) {
            return props.projectId;
        }
        return Number(params.id);
    }, [params, props.projectId]);
    const { authorizedApi } = useApi(UsersRycApiClient);
    const projectApi = useApi(ProjectsRycApiClient);
    const [users, setUsers] = React.useState<UserForProjectDto[]>([]);
    const getUsersForProject = React.useCallback(async () => {
        if (projectId) {
            const usersLoc = await authorizedApi?.getUsersForProject(projectId);
            setUsers(usersLoc?.users ?? []);
        }

    }, [authorizedApi, projectId]);
    const [addingUser, setAddingUser] = React.useState(false);
    const [addedUser, setAddedUser] = React.useState<UserDto | null>(null);
    const [deletingUser, setDeletingUser] = React.useState<UserForProjectDto | null>(null);
    React.useEffect(() => {
        getUsersForProject();
    }, [getUsersForProject]);
    React.useEffect(() => {
        setCurrentModule(RycIsProjectModule.Users);
    }, [setCurrentModule]);
    React.useEffect(() => {
        setMenuButtons(<></>);
    }, [setMenuButtons]);
    const addRemove = React.useCallback(async (user: UserDto) => {

        projectApi.authorizedApi?.addRemoveProjectUser(new AddRemoveProjectToUserRequest({ projectId, userId: user?.id ?? 0 })).then(() => { setAddedUser(null); getUsersForProject(); setAddingUser(false); setDeletingUser(null); });
    }, [projectApi.authorizedApi, projectId, getUsersForProject]);
    return (
        <Box>
            <DeleteDialog
                data={deletingUser}
                onDeleteAgree={async (data) => {
                    addRemove(data);

                }}
                onClose={(data) => { setDeletingUser(null); }}
                open={deletingUser !== null}
            />
            <Typography color='secondary' textAlign={'center'} variant='h6'> Seznam uživatelů</Typography>
            {!addingUser && <Button variant='contained' fullWidth startIcon={<PersonAdd />} onClick={() => { setAddingUser(true) }}>Přidat uživatele</Button>}
            {addingUser && <Stack p={1} spacing={1} width={'100%'} direction={'row'}>
                <UsersSelect onUserSelect={(user) => { setAddedUser(user) }} selectedUser={addedUser} />
                <IconButton
                    disabled={!addedUser}
                    color='primary'
                    onClick={() => {
                        if (addedUser)
                            addRemove(addedUser);
                    }}><Check /></IconButton>
                <IconButton color='error' onClick={() => { setAddingUser(false) }}><Close /></IconButton>
            </Stack>}
            <Box >{users.map((user) => (
                <Box
                    display='flex'
                    alignItems='center'
                    justifyContent={'space-between'}
                    width='100%'
                    sx={{
                        cursor: 'pointer',
                        p: 1,
                        '&:hover': { backgroundColor: 'grey.200' },
                        borderBottom: '1px solid #C3C3C3',
                        // bgcolor: selectedUser?.id === user.id ? theme.palette.primary
                        //     .light : 'transparent',
                    }}
                    // onClick={() => setSelectedUser(user)}
                    key={user.id}>
                    <Box textAlign={'left'}>
                        <Typography variant='body1'>{user.name}</Typography>
                        <Typography variant='body2'>{user.email}</Typography>
                    </Box>
                    <IconButton onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeletingUser(user);
                    }}>
                        <DeleteOutline />
                    </IconButton>
                </Box>
            ))}</Box>
        </Box>
    );
}
